<template>
  <div
    class="popup_wrap"
    style="width:650px;"
  >
    <button
      class="layer_close"
      @click="$emit('close')"
    >
      close
    </button>
    <div class="popup_cont">
      <h1 class="page_title">{{ $t('msg.ONEX050P170.014') }}</h1><!-- LOI Files -->
      <div class="content_box">
        <h2 class="content_title">{{ $t('msg.ONEX050P170.015') }}</h2><!-- LOI Files 첨부 -->
        <DEXT5Upload
          :key="params.uploadFileInfos.length"
          ref="dextupload"
          id="dextupload1"
          width="100%"
          height="200px"
          :category="true"
          :file-info="params.uploadFileInfos"
          :category-info="categoryList"
          :button-bar-edit="btnDownYn"
          :button-bar-add="btnAddYn"
        />
        <h2 class="content_title">{{ $t('msg.ONEX050P170.016') }}</h2><!-- LOI Template 다운로드 -->
        <span
          class="dv col_6"
          style="display:flex;"
        >
          <select v-model="loiCategory">
            <option disabled hidden value="">선택</option>
            <option
              v-for="item in downloadCategoryList"
              :key="item.value"
              :value="item.value"
            >
              {{ item.category }}
            </option>
          </select>
          <a
            class="button sm"
            href="#"
            style="margin-left:8px; flex:0 0 auto;"
            @click.prevent="excelDownloadByCategory"
          >
            {{ $t('msg.ONEX050G020.021') }}
          </a>
        </span>
      </div>
      <div v-if="!btnDownYn" class="mt10 text_center">
        <a
          class="button blue lg"
          href="#"
          @click.prevent="insertFile()"
        >{{ $t('msg.ONEX050P170.003') }}</a><!-- 저장 -->
      </div>
      <div v-else class="mt10 text_center">
        <a class="button blue lg" @click="$emit('close')">{{ $t('msg.NEWB010P040.001') }}</a><!-- 닫기 -->
      </div>
    </div>
  </div>
</template>

<script>

import { rootComputed } from '@/store/helpers'
import DEXT5Upload from '@/components/DEXT5Upload'
import docs from '@/api/rest/trans/docs'

export default {
  name: 'BLLoiPop',
  components: { DEXT5Upload },
  props: {
    parentInfo: {
      type: Object,
      default: function () {
        return {
          type: '',
          blNo: '',
          podCtrCd: '',
          uploadFileList: [],
          btnDownYn: false,
          btnAddYn: false
        }
      }
    }
  },
  data () {
    return {
      loiCategory: '',
      categoryList: [], // 업로드용 (etc 포함)
      downloadCategoryList: [], // 다운로드용 (etc 제외)
      loiCategoryMap: {
        loiRequest: { category: this.$t('msg.ONEX050P170.017'), value: '01' },
        overweightLOI: { category: this.$t('msg.ONEX050P170.018'), value: '02' },
        dopLOI: { category: this.$t('msg.ONEX050P170.019'), value: '03' },
        podDirectDeliveryLOI: { category: this.$t('msg.ONEX050P170.020'), value: '07' },
        srilankaLOI: { category: this.$t('msg.ONEX050P170.021'), value: '08' },
        vgmLOI: { category: this.$t('msg.ONEX050P170.022'), value: '09' },
        thirdCountryLOI: { category: this.$t('msg.ONEX050P170.023'), value: '10' },
        etc: { category: this.$t('msg.ONEX050P170.013'), value: '04' }
      },

      params: {
        blNo: '',
        type: '',
        podCtrCd: '',
        // 첨부파일 리스트(실제 입력)
        uploadFileInfos: []
      },
      btnDownYn: false,
      btnAddYn: false,
      // Dext Uploader와 연결되어 있는 배열
      uploadFileList: [],
      bookingInfo: {
        type: Object,
        default: null
      }
    }
  },
  computed: {
    ...rootComputed
  },
  created () {
    this._ = require('lodash')
    this.params = { ...this.params, ...this.parentInfo }
    this.params.uploadFileInfos = this.parentInfo.uploadLoiFileList
    // 기존 파일의 원본 신원(카테고리+요청차수+파일번호)을 객체에 각인한다.
    // DEXT 카테고리 드롭다운은 category만 덮어쓰므로 loiOrg는 로드 시점 DB 값을 유지하며,
    // 저장 시 보존 대상 키는 화면 값이 아니라 이 각인값을 사용한다.
    // 이미 각인된 객체는 다시 덮어쓰지 않는다(변경된 카테고리가 원본으로 굳는 것 방지).
    ;(this.parentInfo.uploadLoiFileList || []).forEach(f => {
      if (f.newFlag !== 'Y' && f.loiOrg === undefined) {
        f.loiOrg = { category: f.category, reqSeq: f.reqSeq, fileSeq: f.fileSeq }
      }
    })
    this.btnDownYn = this.parentInfo.btnDownYn
    this.btnAddYn = this.parentInfo.btnAddYn
    this.categoryList = Object.values(this.loiCategoryMap)
    this.downloadCategoryList = this.categoryList.filter(v => v.value !== '04') // etc 제거
    this.initPopup()
  },
  mounted () {
    // this.initPopup()
  },
  methods: {
    async initPopup () {
      const TH = this
      const parentInfo = TH.parentInfo
      // 로그인 여부 체크
      if (!this.auth.userId) {
        await this.$ekmtcCommon.asyncAlertMessage({ message: this.$t('msg.REPORT_PDF.115') }) // 로그인을 확인해주세요.
        this.$emit('close')
        return
      }

      const ctrCd = this.memberDetail.userCtrCd

      // await Promise.all([
      //   this.settingCategory(),
      //   this.getBLAttachList(),
      //   this.getBLAttachLoiUploadList(),
      //   this.getIranUploadList()
      // ])

      const arrPromise = [
        this.settingCategory()
        // this.getBLAttachList()
      ]

      // if (ctrCd === 'KR' && this.params.type === 'BL') {
      //   arrPromise.push(this.getBLAttachLoiUploadList())
      // }
      // if (this.params.podCtrCd === 'IR') {
      //   arrPromise.push(this.getIranUploadList())
      // }

      arrPromise.push(
        docs.getReqDocBookingBl(parentInfo.blNo, TH.parentInfo.bkgNo, parentInfo.type).then(async res => {
          const result = res.data
          await TH.setBookingInfo(result)
        })
      )

      await Promise.all(arrPromise)
    },
    settingCategory () {
      // Default
      this.categoryList = [
        this.loiCategoryMap.loiRequest,
        this.loiCategoryMap.overweightLOI,
        this.loiCategoryMap.dopLOI,
        this.loiCategoryMap.podDirectDeliveryLOI,
        this.loiCategoryMap.srilankaLOI,
        this.loiCategoryMap.vgmLOI,
        this.loiCategoryMap.thirdCountryLOI,
        this.loiCategoryMap.etc
      ]
    },
    validationCategory () {
      let isOk = true

      // 파일리스트 카테고리 선택 여부 검사
      this.params.uploadFileInfos.forEach(element => {
        if (element.category === undefined || element.category === '') {
          this.$ekmtcCommon.alertDefault(this.$t('msg.ONEX050P170.009')) // 카테고리가 선택되지 않은 파일이 있습니다.
          isOk = false
          return false
        }
      })

      if (!isOk) {
        return isOk
      }

      // 기존 파일 검증 - 원본 신원을 확인할 수 없거나 카테고리가 변경된 상태면 저장을 중단한다.
      // (보존 대상 키가 틀리면 서버가 원본 행을 삭제해 첨부 원문이 유실되므로 fail-closed로 처리한다)
      for (const file of this.params.uploadFileInfos) {
        if (file.newFlag === 'Y') {
          continue
        }

        if (!file.loiOrg) {
          this.$ekmtcCommon.alertDefault(this.$t('msg.ONEX050P170.026'))
          return false
        }

        if (file.loiOrg.category !== file.category) {
          this.$ekmtcCommon.alertDefault(this.$t('msg.ONEX050P170.025'))
          return false
        }
      }

      return isOk
    },
    // 저장 or 수정
    async insertFile () {
      const TH = this
      if (this.validationCategory()) {
        const categories = this.params.uploadFileInfos.map(file => file.category)
        const uniqueCategories = new Set(categories)

        if (categories.length !== uniqueCategories.size) {
          this.$ekmtcCommon.alertDefault(this.$t('msg.ONEX050P170.024'))
          return
        }
        // 저장하시겠습니까
        if (await this.$ekmtcCommon.asyncAlertMessage({ message: TH.$t('msg.ONEX050P170.010'), useConfirmBtn: true })) {
          await TH.onConfirmInsert()
        }
      }
    },
    // 저장 Confirm '확인' 클릭 시 콜백 메소드
    async onConfirmInsert () {
      const TH = this

      this.params.reqCatCd = this.params.uploadFileInfos[0]?.category || ''
      this.params.bkgNo = TH.bookingInfo.bkgNo
      this.params.blNo = TH.bookingInfo.blNo
      this.params.vslCd = TH.bookingInfo.vslCd
      this.params.voyNo = TH.bookingInfo.voyNo
      this.params.polCtrCd = TH.bookingInfo.polCtrCd
      this.params.polPortCd = TH.bookingInfo.polPortCd
      this.params.podCtrCd = TH.bookingInfo.podCtrCd
      this.params.podPortCd = TH.bookingInfo.podPortCd
      this.params.shprCstNo = TH.bookingInfo.shprCstNo
      this.params.shprCstNm = TH.bookingInfo.shprCstNm
      let isFail = false
      let uploadFileInfos = []
      for (const file of this.params.uploadFileInfos) {
        if (file.newFlag === 'Y') {
          // 신규 업로드 파일: CM530I 임시파일 fileId 그대로 전송
          uploadFileInfos.push(file)
        } else {
          // 기존 파일: 화면에서 변형될 수 있는 값 대신 로드 시점 원본 신원을 전송한다.
          // 서버는 이 키로 보존 대상을 판단하므로 반드시 DB 실제 값이어야 한다.
          // (fileId는 다운로드용 URL 문자열이라 서버 int 필드에 바인딩되지 않도록 0으로 보낸다)
          uploadFileInfos.push({
            originalName: file.originalName,
            size: file.size,
            category: file.loiOrg.category,
            reqSeq: file.loiOrg.reqSeq,
            fileSeq: file.loiOrg.fileSeq,
            newFlag: 'N',
            guid: '',
            fileId: 0
          })
        }
      }
      const sendParams = {
        ...this.params,
        uploadFileInfos: uploadFileInfos
      }
      const response = await docs.reqLoiSubmit(sendParams)
      if (response.headers.respcode !== 'C0000') {
        isFail = true
      }
      if (!isFail) {
        TH.$ekmtcCommon.alertCallback(
          TH.$t('msg.ONEX050P170.011'),
          function () {
            TH.$emit('selectFunc')
            TH.$emit('close')
          }
        )
      } else {
        this.$ekmtcCommon.alertDefault(
          this.$t('msg.ONEX050P170.012')
        )
      }
    },
    async excelDownloadByCategory () {
      if (!this.loiCategory) {
        this.$ekmtcCommon.alertDefault(this.$t('msg.ADMN040G020.041'))
        return
      }

      let result

      let params = {
            blNo: this.parentInfo.blNo,
            bkgNo: this.bookingInfo.bkgNo,
            type: this.parentInfo.type
          }

      switch (this.loiCategory) {
        case '01':
          params.fileNm = 'LOIRequest.xlsx'
          result = await docs.getExcelDownload(params)
          break

        case '02':
          params.fileNm = 'OverweightLOI.xlsx'
          result = await docs.getOverweightLOI(params)
          break

        case '03':
          params.fileNm = 'DopLOI.xlsx'
          result = await docs.getDopLOI(params)
          break

        case '07':
          params.fileNm = 'PodDirectDeliveryLOI.xlsx'
          result = await docs.getPodDirectDeliveryLOI(params)
          break

        case '08':
          params.fileNm = 'SrilankaLOI.xlsx'
          result = await docs.getSrilankaLOI(params)
          break

        case '09':
          params.fileNm = 'VgmLOI.xlsx'
          result = await docs.getVgmLOI(params)
          break

        case '10':
          params.fileNm = '3rdCountryLOI.xlsx'
          result = await docs.get3rdCountryLOI(params)
          break

        default:
          return
      }

      this.downloadBlob(result, params.fileNm)
    },
    downloadBlob (result, fileName) {
      const blob = new Blob(
        [result.data],
        { type: result.headers['content-type'] }
      )

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(result.data, fileName)
      } else {
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')

        link.href = url
        link.target = '_self'
        link.download = fileName
        link.click()

        window.URL.revokeObjectURL(url)
      }
    },
    async setBookingInfo (result) {
      this.bookingInfo = result

      if (this.$ekmtcCommon.isNotEmpty(this.bookingInfo.blNo)) {
        const blNo = this.bookingInfo.blNo
        await docs.getBkgContainerInfo(blNo).then(res => {
          console.log(res)
        })
      }
    }
  }
}
</script>
